import { useRef } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useAppSelector } from '../hooks/reduxHooks';
import '../styles/Login.css';
import ScreenLoader from '../components/atoms/ScreenLoader';
import utils from '../utils';

const Login = ({ history }) => {
  const {
    isLogged,
    loginData: { user },
  } = useAppSelector(({ adminReducer }) => adminReducer);

  const location = useLocation();
  const timeDifferenceRef = useRef(0);
  const params = new URLSearchParams(location.search);
  const SSOtoken = params.get('token') || null;

  // si viene token en la url
  if (SSOtoken) history.push('/auth', { SSOtoken });

  // si el token ya expiro lo saco de la sesion
  if (isLogged) {
    const currenTime = new Date();
    const tokenExpTime = utils.parseJwt(user?.token || '');
    const timeDifference = utils.getTimeDifferenceInSeconds(tokenExpTime.exp * 1000, currenTime.getTime());
    timeDifferenceRef.current = timeDifference;
    if (timeDifference <= 0 && !SSOtoken) {
      history.push('/logout');
    }
  }

  if (isLogged && timeDifferenceRef.current >= 0) {
    return <Redirect to="/bandeja/colaborador" />;
  }

  return <ScreenLoader loading />;
};

export default Login;
